export enum ConfigitForceableDisplay {
    // Will prevent values from being displayed
    Hide = 'Hide',
    // Will put forceable values in the order they are defined in configit model
    Interleaved = 'Interleaved',
    // Will put all forceable values in the end of the list of values
    Last = 'Last',
}
